import { createContext, useContext } from 'react'

export const EnabledContext = createContext({ enabled: false })
export const useEnabledContext = () => useContext(EnabledContext)
